export default __webpack_public_path__ + "static/media/Kale-Closeup-400px.ad402e70.jpg";